import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Dropdown, Form, Input, Menu, Modal, Row, Select, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import Title from 'antd/es/typography/Title';
import ModalRejectComponent from 'app/shared/component/modal/reject';
import * as _ from 'lodash';
import ApproveObjectiveKRComponent from './approve-objective';
import { cancelProcess, getEntities, getEntitiesAdjustment, getLimitedProcessApprove, getLimitedProcessMaxOrderLevelAdjustment, resetCategoryApproveView } from './category-approve.reducer';
import { columns as baseColumns } from './config';
import PreviousCategoryApproveComponent from './previous-category-approve';
import { setFilterCategoryApprove, setListFilterApprovalLevel } from 'app/entities/filters/filters.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import { getTypeSelectboxApprovalLevel } from '../../approval-level.reducer';

type ICategoryApproveProps = {
    isOpen: boolean;
    onClose: () => void;
    planPeriodId: string;
};

const { Search } = Input;

export const CategoryApproveComponent = ({ isOpen, onClose, planPeriodId }: ICategoryApproveProps) => {
    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryApprove.entities);
    const loading = useAppSelector(state => state.categoryApprove.loading);
    const account = useAppSelector(state => state.authentication.account);
    const filters = useAppSelector(state => state.filters.categoryApprove);
    const [form] = Form.useForm();

    const [isOpenModalApproveItemSelected, setOpenModalApproveItemSelected] = useState(false);
    const [processSelected, setProcessSelected] = useState(null);
    const [isOpenModalConfirmCancelProcess, setOpenModalConfirmCancelProcess] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
    const [isOpenModalPreApproval, setOpenModalPreApproval] = useState(false);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [planPeriodIdSelected, setPlanPeriodIdSelected] = useState(null);
    const [approvalLevelColumns, setApprovalLevelColumns] = useState<ColumnsType<any>>([]);
    const [isSelectionComplete, setSelectionComplete] = useState(false);


    const dropDownKrAction = [
        {
            key: 1,
            label: 'Xem kết quả phê duyệt các lần trước',
            onclick: (item) => handleViewPreviousApprove(item),
        },
    ];

    const columnsConfig = [{
        title: 'Hành động',
        key: 'action',
        width: 100,
        render(item: any) {
            if (item.ownerId)
                return (
                    <div className="action">
                        {item.documentId &&
                            <span className="action-view">
                                <Tooltip title="Xem chi tiết">
                                    <FontAwesomeIcon
                                        onClick={() => {
                                            handleOpenModalApproveItemSelected(item);
                                        }}
                                        icon="eye"
                                    />
                                </Tooltip>
                            </span>
                        }
                        {(item.documentId && item.isFinished === false) &&
                            <span className="action-delete">
                                <Tooltip title="Dừng">
                                    <FontAwesomeIcon
                                        onClick={() => { handleOpenModelConfirmCancelProcess(item) }}
                                        icon="ban"
                                    />
                                </Tooltip>
                            </span>
                        }
                    </div>
                )
        }
    }]

    const resetModalState = () => {
        form.resetFields();
        setOpenModalApproveItemSelected(false);
        setProcessSelected(null);
        setOpenModalConfirmCancelProcess(false);
        setContextMenu(null);
        setOpenModalPreApproval(false);
        setExpandedRowKeys([]);
        setSelectedPeriod(null);
        setPlanPeriodIdSelected(null);
        setApprovalLevelColumns([]);
        setSelectionComplete(false);
    };

    // useEffect(() => {
    //     handleGetTreeOrg();
    // }, [filters])

    // useEffect(() => {
    //     handleGetProcessApproveLimited();
    // }, [])

    useEffect(() => {
        if (isOpen) {
            resetModalState();
            dispatch(resetCategoryApproveView());
        }
    }, [isOpen])

    useEffect(() => {
        if (Object.keys(treeData).length > 0) {
            const allRowKeys = getAllRowKeys(treeData);
            setExpandedRowKeys(allRowKeys);
        } else {
            setExpandedRowKeys([]);
        }
    }, [treeData])

    const newColumns: ColumnsType<any> = _.uniqBy([...baseColumns, ...(isSelectionComplete ? approvalLevelColumns : []), ...columnsConfig], 'key') as unknown as ColumnsType<any>;

    const mapApprovalLevelColumns = (levels = []) => {
        return levels.map(element => ({
            title: `Cấp ${element}`,
            key: `cap_${element}`,
            render(item) {
                if (item?.ownerId && item?.levelStatuses !== null &&
                    item?.levelStatuses?.[`LevelStatus_${element}`]?.status)
                    return (
                        <span>{item?.levelStatuses?.[`LevelStatus_${element}`]?.approveLevelName} {item?.levelStatuses?.[`LevelStatus_${element}`]?.status}</span>
                    )
            },
        }));
    };

    const handleGetTreeOrg = (params: { userId: string, planPeriodId: string }) => {
        if (selectedPeriod === 3) {
            dispatch(getEntitiesAdjustment({ userId: account?.id, planPeriodId: planPeriodIdSelected }))
        } else {
            dispatch(getEntities({ userId: account?.id, planPeriodId: planPeriodIdSelected }))
        }
    }

    const handleGetProcessApproveLimited = (params: { userId: string, planPeriodId: string }) => {
        dispatch(getLimitedProcessApprove(params)).then((res) => {
            if (res && res.payload) {
                const result = (res.payload as any)?.data || [];
                setApprovalLevelColumns(mapApprovalLevelColumns(Array.isArray(result) ? result : []));
            }
        });
    }

    const handleGetProcessApproveLimitedAdjustment = (params: { userId: string, planPeriodId: string }) => {
        dispatch(getLimitedProcessMaxOrderLevelAdjustment(params)).then((res) => {
            if (res && res.payload) {
                const result = (res.payload as any)?.data || [];
                setApprovalLevelColumns(mapApprovalLevelColumns(Array.isArray(result) ? result : []));
            }
        });
    }


    const getAllRowKeys = (item, index = 0) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.ownerName}_${index}_${idx}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children, idx));
            }

            return keys;
        }, []);
    };

    const handleFreeTextSearchQuery = query => {
        dispatch(setFilterCategoryApprove({ ...filters, searchText: query }))
    };

    const handleClose = () => {
        resetModalState();
        dispatch(resetCategoryApproveView())
        onClose();
    };

    const handleOpenModalApproveItemSelected = (itemSelected) => {
        setOpenModalApproveItemSelected(true);
        setProcessSelected(itemSelected);
    }

    const handleCloseModalApproveItemSelected = (isReload = false) => {
        setOpenModalApproveItemSelected(false);
        setProcessSelected(null);

        if (isReload) {
            handleGetTreeOrg({ userId: account?.id, planPeriodId: planPeriodIdSelected });
        }
    }

    const handleOpenModelConfirmCancelProcess = (process) => {
        setProcessSelected(process);
        setOpenModalConfirmCancelProcess(true)
    }

    const handleCancelProcess = (reason: string) => {
        const payload = {
            documentId: processSelected?.documentId,
            ownerId: processSelected?.ownerId,
            userId: account?.id,
            reason
        }
        dispatch(cancelProcess(payload)).then(() => {
            handleGetTreeOrg({ userId: account?.id, planPeriodId: planPeriodIdSelected });
        });
        setOpenModalConfirmCancelProcess(false);
    }

    const handleRightClick = (event, record, rowIndex) => {
        event.preventDefault();
        if (record.documentId && record.ownerId) {
            const { clientX, clientY } = event;
            setContextMenu(
                <Menu>
                    {dropDownKrAction
                        .map(item =>
                            <Menu.Item key={item.key} onClick={() => { item.onclick(record) }}>{item.label}</Menu.Item>
                        )}
                </Menu>
            );
            setMenuPosition({ x: clientX, y: clientY });
        }
    };

    const handleViewPreviousApprove = (record) => {
        setProcessSelected(record);
        setTimeout(() => {
            setOpenModalPreApproval(true);
        }, 0);
    }
    const handleChangePlanPeriod = (value: string) => {
        setPlanPeriodIdSelected(value);
        const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
        if (detailPlanPeriod) {
            dispatch(
                setListFilterApprovalLevel({
                    ...filters,
                    planPeriodName: detailPlanPeriod.name,
                    planPeriodId: value,
                    planPeriodType: detailPlanPeriod.planPeriodType,
                }),
            );
        }
    };

    const handleCloseModalPreviousApprove = () => {
        setOpenModalPreApproval(false);
        setTimeout(() => {
            setProcessSelected(null);
        }, 300);
    }

    const transformData = (data, index = 0) => {
        return data.map((item, idx) => {
            return {
                ...item,
                key: `${item?.ownerName}_${index}_${idx}`, // Create a unique key for each level
                children: item.children ? transformData(item.children, idx) : undefined
            };
        });
    };

    // useEffect(() => {
    //     handleGetTreeOrg();
    // }, [filters])

    // useEffect(() => {
    //     handleGetProcessApproveLimited();
    // }, [])

    const handleFormValuesChange = (changedValues, allValues) => {
        dispatch(resetCategoryApproveView());
        setApprovalLevelColumns([]);
        setExpandedRowKeys([]);
        setSelectionComplete(false);

        if (allValues.selectPlan && allValues.selectedPeriod) {
            setPlanPeriodIdSelected(allValues.selectPlan);
            setSelectedPeriod(allValues.selectedPeriod);
            setSelectionComplete(true);

            if (allValues.selectedPeriod === 2) {
                dispatch(getEntities({ userId: account?.id, planPeriodId: allValues.selectPlan }))
                handleGetProcessApproveLimited({ userId: account?.id, planPeriodId: allValues.selectPlan });
            }

            if (allValues.selectedPeriod === 3) {
                dispatch(getEntitiesAdjustment({ userId: account?.id, planPeriodId: allValues.selectPlan }));
                handleGetProcessApproveLimitedAdjustment({ userId: account?.id, planPeriodId: allValues.selectPlan })
            }
        }

        return
    }


    const planPeriodList = useAppSelector(state => state.planPeriod.entities);
    const typeSelectboxData = useAppSelector(state => state.approvalLevel.typeSelectbox);


    useEffect(() => {
        dispatch(getTypeSelectboxApprovalLevel())
    }, []);


    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Danh mục phê duyệt</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={18}>
                        <Row className='w-100'>
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                </div>
                <Row className='w-100'>
                    <Col md={12}>
                        <Form
                            form={form}
                            layout="vertical"
                            onValuesChange={handleFormValuesChange}
                        >
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item label="Kì kế hoạch" name={"selectPlan"} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                                        <Select className="w-100" onChange={handleChangePlanPeriod} size="large" placeholder="Chức năng" filterOption={filterOption} options={planPeriodList.map(x => ({ label: x.name, value: x.id }))} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Loại quy trình" name={'selectedPeriod'} rules={[{ required: true, message: "Vui lòng nhập phiên bản quy trình" }]}>
                                        <Select className="w-100" size="large" placeholder="Chức năng" filterOption={filterOption} options={typeSelectboxData.map(x => ({ label: x.label, value: x.value }))} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Table scroll={{ y: '60vh' }} loading={isSelectionComplete && loading} bordered dataSource={isSelectionComplete ? transformData(treeData) : []}
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }} onRow={(record, index) => {
                        return {
                            onContextMenu: (event) => handleRightClick(event, record, index),
                        };
                    }} pagination={false} columns={newColumns} />
            </div>
            {contextMenu && (
                <Dropdown
                    overlay={contextMenu}
                    open
                    trigger={['contextMenu']}
                    placement="bottomLeft"
                    onOpenChange={(flag) => !flag && setContextMenu(null)}
                    overlayStyle={{
                        position: 'fixed',
                        top: menuPosition.y,
                        left: menuPosition.x,
                        zIndex: 1000,
                    }}
                >
                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100vh' }} />
                </Dropdown>
            )}
            {isOpenModalApproveItemSelected && <ApproveObjectiveKRComponent selectedPeriod={selectedPeriod} planPeriodId={planPeriodIdSelected} accountTableId={processSelected?.ownerId} accountableName={processSelected?.ownerName} documentId={processSelected?.documentId} isOpen={isOpenModalApproveItemSelected} onClose={handleCloseModalApproveItemSelected} />}
            {isOpenModalPreApproval && <PreviousCategoryApproveComponent selectedPeriod={selectedPeriod} accountTableId={processSelected?.ownerId} accountTableName={processSelected?.ownerName} planPeriodId={planPeriodIdSelected} isOpen={isOpenModalPreApproval} onClose={handleCloseModalPreviousApprove} />}
            <ModalRejectComponent
                visible={isOpenModalConfirmCancelProcess}
                onCancel={() => {
                    setOpenModalConfirmCancelProcess(false);
                }}
                onReject={handleCancelProcess}
                title={`Bạn có chắc chắn muốn dừng quy trình của ${processSelected?.ownerName}`}
            />
        </Modal>
    );
};

export default CategoryApproveComponent;
